export const API_ENDPOINT = "https://mindnotes-nimhans.net/mindnotes/api";
export const AUTH_ENDPOINT = "https://mindnotes-nimhans.net/mindnotes";
export const GOOGLE_CLIENT_ID = "1060811530619-motgqm15keanft3jf63m3p71jnn5d4l1.apps.googleusercontent.com";
// export const API_ENDPOINT = "https://test.ehrc.in.net/mindnotes/api";
// export const AUTH_ENDPOINT = "https://test.ehrc.in.net/mindnotes";
// export const GOOGLE_CLIENT_ID = "587637741081-iup75gfeeslt2c9bt78d3rjlrl1qeabe.apps.googleusercontent.com";
export const ADDITIONAL_HEADERS = "*";
export const FIREBASE_NOTIFICATION_PAGE = "https://console.firebase.google.com/project/testandroidlogin-2a0d2/notification/compose";
export const ENCRYPTION_KEY = 'betK2!psAsQSa5KzF8PLc3Mh!VDY3Wm@4P';
// export const GOOGLE_CLIENT_ID = "587637741081-91bc1k36nm69lc7nlfohck339dcufgoi.apps.googleusercontent.com";